module.exports = __webpack_public_path__ + "static/media/Informationicon01@3x.9cf4aae6.png";